<template>
  <div class="rename-wrapper container-inner pt-30 pb-50">
    <h5 class="c-text_title">マイページ</h5>
    <div class="tile is-ancestor">
      <div class="tile is-3 is-sidebar is-vertical is-parent">
        <div class="tile is-child"><SidebarMyPage /></div>
      </div>
      <div class="tile is-parent">
        <div class="tile is-child content-padding">
          <h4 class="mypage-block-title">{{ $route.params.id ? $t('Header_33') : $t('Header_32') }}</h4>
          <message-area></message-area>
          <div class="columns">
            <div class="column is-half-desktop">
              <AddressForm @onSubmit="updateAddress"></AddressForm>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false" /></div
></template>
<style lang="scss" src="./add-edit-address.scss" scoped>
</style>

<script>
import SidebarMyPage from '@/components/sidebar/sidebar-mypage/sidebar-mypage';
import MessageArea from '@/components/common/message-area/message-area.vue';
import messageUtils from '@/utils/mixins/messageUtils';
import AddressForm from '@/views/customer/components/address-form/address-form';
import { addDeliveryAddress, updateDeliveryAddress } from '../../../../services/profile.service';
export default {
  name: 'AddEditAddress',
  components: {
    SidebarMyPage,
    'message-area': MessageArea,
    AddressForm
  },
  mixins: [messageUtils],
  props: {
    messageProp: {
      type: [String],
      default: ''
    }
  },
  data() {
    return {
      addressId: null
    };
  },
  watch: {
    '$route.params.messageProp': function() {
      this.setSuccessMessage({ messageId: this.$route.params.messageProp });
      this.addressId = this.$route.params.id;
    }
  },
  mounted() {
    this.addressId = this.$route.params.id;
  },
  methods: {
    async updateAddress(data) {
      this.clearMessage();
      if (this.addressId) {
        this.loading++;
        try {
          const updateResult = await updateDeliveryAddress(
            this.addressId,
            data.receiverName,
            data.zipcode,
            data.prefecture,
            data.address,
            data.phoneNumber
          );
          this.updateMessage(updateResult.status, updateResult.result);
        } catch (e) {
          let mes = {
            message: e.message,
            messageId: 'EF2204_Content'
          };
          this.setErrorMessage(mes);
        }

        this.loading--;
      } else {
        this.loading++;
        try {
          const addResult = await addDeliveryAddress(
            data.receiverName,
            data.zipcode,
            data.prefecture,
            data.address,
            data.phoneNumber
          );
          this.updateMessage(addResult.status, addResult.result);
          if (addResult.status) {
            this.$router.push({
              name: 'CustomerEditAddress',
              params: {
                id: addResult.result.data[0].id,
                messageProp: addResult.result.messageId || ''
              }
            });
          }
        } catch (e) {
          let mes = {
            message: e.message,
            messageId: 'EF2204_Content'
          };
          console.log(e);
          this.setErrorMessage(mes);
        }
        this.loading--;
      }
    }
  }
};
</script>
